<template>
	<div class="body-mid">
		<div style="background: #E5EDFB;">
			<div style="display: inline-block; font-size: 18px;font-weight: bold;line-height: 40px;color: white;
			padding: 0 20px;height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;">
				我的订阅
			</div>
		</div>
		<div class="checkBox">
			<div @click="activeCheck = 1" :class="activeCheck == 1 ? 'checkActive':''">用户</div>
			<div @click="activeCheck = 2" :class="activeCheck == 2 ? 'checkActive':''">项目需求</div>
			<div @click="activeCheck = 3" :class="activeCheck == 3 ? 'checkActive':''">资源工具</div>
			<div @click="activeCheck = 4" :class="activeCheck == 4 ? 'checkActive':''">解决方案</div>
			<div @click="activeCheck = 5" :class="activeCheck == 5 ? 'checkActive':''">产品服务</div>
		</div>
		<div v-show="activeCheck == 1">
			<div v-if="OrderUserList.total">
				<div style="padding: 20px;box-sizing: border-box;padding-top: 35px;">
					<div class="detail" v-for="(item,index) in OrderUserList.data">
						<div class="detail-pic">
							<div class="image"><img :src='getImgSrc(item.user_info.avatar)' alt=""></div>
							<div class="renzheng">{{item.authentication.wechat_data == 1? '未认证':'已认证'}}</div>
						</div>
						<div class="detail-content">
							<div class="top">
								<div class="username">{{item.user_info.nickname}}</div>
								<div style="display: flex;">
									<div class="fans guanzhu" @click="toCancelFansNperson(item)"><i class="el-icon-star-off"></i> 取消关注</div>
									<div class="fans letter"  @click="$router.push(`/userCenter/pthd/myMessage?type=${3}&id=${item.leader_id}`)"><i class="el-icon-message"></i> 站内信</div>
								</div>
							</div>
							<div class="company">
								{{item.authentication.company == null ?'未入驻':item.authentication.company}}
							</div>
							<div class="jieshao">
								<p style="display: -webkit-box;
										  -webkit-line-clamp: 2;
										  -webkit-box-orient: vertical;
										  overflow: hidden;
										  text-overflow: ellipsis;
										  word-wrap: break-word;
										">
									{{item.authentication.content}}
								</p>
							</div>
						</div>
					</div>
				</div>
				<div style="padding: 30px;display: flex;justify-content: center;padding-top: 0;">
					<el-pagination background
					 @current-change='getOrderUserList'
					 :page-size="OrderUserList.per_page" layout="prev, pager, next"
						:total="OrderUserList.total">
					</el-pagination>
				</div>
			</div>
			<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
				<el-empty :image-size="200" description="没有关注的用户"></el-empty>
			</div>
		</div>
		<div v-show="activeCheck == 2">
			<div style="padding: 20px;box-sizing: border-box;padding-top: 35px;">
				<el-table :data="projectList.data" stripe style="width: 100%" border="">
					<el-table-column prop="subjectcate_name" label="科学分类" width="141" :resizable="false">
					</el-table-column>

					<el-table-column prop="industry_name" label="行业分类" width="165" :resizable="false">
					</el-table-column>

					<el-table-column prop="title" label="资源标题" width="321" :resizable="false">
					</el-table-column>
					<el-table-column  label="更新时间" width="204" :resizable="false">
						<template slot-scope="scope">
						{{timeConversion(scope.row.updatetime)}}
						</template>
					</el-table-column>

					<el-table-column label="操作" width="247" :resizable="false">
							<template slot-scope="scope">
							<span style="cursor: pointer;color: #0052D9 !important;" @click='cancelSubscribeProject(scope.row)'>取消订阅</span>
							</template>
					</el-table-column>

				</el-table>
			</div>
			<div style="padding: 30px;display: flex;justify-content: center;padding-top: 0;">
				<el-pagination background :page-size="projectList.per_page" layout="prev, pager, next"
						:total="projectList.total"
				@current-change='getMyProject'>
				</el-pagination>
			</div>
		</div>
		<div v-show="activeCheck == 3">
			<div style="padding: 20px;box-sizing: border-box;padding-top: 35px;">
				<el-table :data="toolList.data" stripe style="width: 100%" border="">
					<el-table-column prop="subjectcate_name" label="科学分类" width="141" :resizable="false">
					</el-table-column>
			
					<el-table-column prop="industry_name" label="行业分类" width="165" :resizable="false">
					</el-table-column>
			
					<el-table-column prop="title" label="资源标题" width="321" :resizable="false">
					</el-table-column>
					<el-table-column  label="更新时间" width="204" :resizable="false">
						<template slot-scope="scope">
						{{timeConversion(scope.row.updatetime)}}
						</template>
					</el-table-column>
			
					<el-table-column label="操作" width="247" :resizable="false">
							<template slot-scope="scope">
							<span style="cursor: pointer;color: #0052D9 !important;" @click='cancelSubscribeTool(scope.row)'>取消订阅</span>
							</template>
					</el-table-column>
			
				</el-table>
			</div>
			<div style="padding: 30px;display: flex;justify-content: center;padding-top: 0;">
				<el-pagination background :page-size="toolList.per_page" layout="prev, pager, next"
						:total="toolList.total"
				@current-change='getMyTools'>
				</el-pagination>
			</div>
		</div>
		<div v-show="activeCheck ==4">
			<div style="padding: 20px;box-sizing: border-box;padding-top: 35px;">
				<el-table :data="solutionList.data" stripe style="width: 100%" border="">
					<el-table-column prop="subjectcate_name" label="科学分类" width="141" :resizable="false">
					</el-table-column>
			
					<el-table-column prop="industry_name" label="行业分类" width="165" :resizable="false">
					</el-table-column>
			
					<el-table-column prop="title" label="资源标题" width="321" :resizable="false">
					</el-table-column>
					<el-table-column  label="更新时间" width="204" :resizable="false">
						<template slot-scope="scope">
						{{timeConversion(scope.row.updatetime)}}
						</template>
					</el-table-column>
			
					<el-table-column label="操作" width="247" :resizable="false">
							<template slot-scope="scope">
							<span style="cursor: pointer;color: #0052D9 !important;" @click='cancelSubscribeSolution(scope.row)'>取消订阅</span>
							</template>
					</el-table-column>
			
				</el-table>
			</div>
			<div style="padding: 30px;display: flex;justify-content: center;padding-top: 0;">
				<el-pagination background :page-size="solutionList.per_page" layout="prev, pager, next"
						:total="solutionList.total"
				@current-change='getMySolution'>
				</el-pagination>
			</div>
		</div>
		<div v-show="activeCheck == 5">
			<div style="padding: 20px;box-sizing: border-box;padding-top: 35px;">
				<el-table :data="productList.data" stripe style="width: 100%" border="">
					<el-table-column prop="subjectcate_name" label="科学分类" width="141" :resizable="false">
					</el-table-column>
			
					<el-table-column prop="industry_name" label="行业分类" width="165" :resizable="false">
					</el-table-column>
			
					<el-table-column prop="title" label="资源标题" width="321" :resizable="false">
					</el-table-column>
					<el-table-column  label="更新时间" width="204" :resizable="false">
						<template slot-scope="scope">
						{{timeConversion(scope.row.updatetime)}}
						</template>
					</el-table-column>
			
					<el-table-column label="操作" width="247" :resizable="false">
							<template slot-scope="scope">
							<span style="cursor: pointer;color: #0052D9 !important;" @click='cancelSubscribeProduct(scope.row)'>取消订阅</span>
							</template>
					</el-table-column>
			
				</el-table>
			</div>
			<div style="padding: 30px;display: flex;justify-content: center;padding-top: 0;">
				<el-pagination background :page-size="productList.per_page" layout="prev, pager, next"
						:total="productList.total"
				@current-change='getMyProduct'>
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeCheck: 1,
				tableData2: [{
					kxfl: '开源数据',
					hyfl: '数据调查',
					title: '开源海洋观测数据采集与分析',
					update: '2023-05-10',
				}],
				OrderUserList: [],
				OrderUserPage: 1,
				projectList:[],
				projectPage:1,
				toolList:[],
				toolPage:1,
				solutionList:[],
				solutionPage:1,
				productList:[],
				productPage:1,
			}
		},
		created() {
			this.getOrderUserList()
			this.getMyProject()
			this.getMyTools()
			this.getMySolution()
			this.getMyProduct()
		},
		methods: {
			async cancelSubscribeProject(item){
				const collect = await this.$api.productCancelCollect({id:item.projectneed_id})
				if(collect.code == 1){
					this.$message({
						message:collect.msg,
						type:'success',
						center:true
					})
					this.projectList.data = this.projectList.data.filter(need=> need.projectneed_id !== item.projectneed_id) 
				}
			},
			async toCancelFansNperson(item) {
				const fans = await this.$api.cancelGeniusFans({
					user_id: item.leader_id
				})
				if (fans.code == 1) {
					this.$message({
						message: fans.msg,
						type: 'success',
					})
				this.OrderUserList.data = this.OrderUserList.data.filter(user=> user.id !== item.id)
				} else {
					this.$message({
						message: fans.msg,
						type: 'warning',
					})
				}
			},
			async cancelSubscribeTool(item){
				const collect = await this.$api.cancelCollectTools({id:item.instrument_id})
				if(collect.code == 1){
					this.$message({
						message:collect.msg,
						type:'success',
						center:true
					})
					this.toolList.data = this.toolList.data.filter(tool=> tool.instrument_id !== item.instrument_id) 
				}
			},
			async cancelSubscribeSolution(item){
				const collect = await this.$api.solutionCancelCollectHandler({id:item.scheme_id})
				if(collect.code == 1){
					this.$message({
						message:collect.msg,
						type:'success',
						center:true
					})
					this.solutionList.data = this.solutionList.data.filter(solution=> solution.scheme_id !== item.scheme_id) 
				}
			},
			async cancelSubscribeProduct(item){
				const collect = await this.$api.productCollectCancelHandler({id:item.product_id})
				if(collect.code == 1){
					this.$message({
						message:collect.msg,
						type:'success',
						center:true
					})
					this.productList.data = this.productList.data.filter(product=> product.product_id !== item.product_id) 
				}
			},
			async getMyProduct(e){
				if(e){
					console.log(e);
					this.productPage = e
				}
				const list = await this.$api.getMySubscribeProduct({
					page: this.productPage
				})
				this.productList = list.data
			},
			async getMySolution(e){
				if(e){
					console.log(e);
					this.solutionPage = e
				}
				const list = await this.$api.getMySubscribeSolution({
					page: this.solutionPage
				})
				this.solutionList = list.data
			},
			async getMyTools(e){
				if(e){
					console.log(e);
					this.toolPage = e
				}
				const list = await this.$api.getMySubscribeTools({
					page: this.toolPage
				})
				this.toolList = list.data
			},
			async getMyProject(e){
				if(e){
					console.log(e);
					this.projectPage = e
				}
				const list = await this.$api.getMySubscribeProject({page:this.projectPage})
				this.projectList = list.data
			},
			async getOrderUserList(e) {
				if(e){
					console.log(e);
					this.OrderUserPage = e
				}
				const list = await this.$api.getMyOrderUserList({
					page: this.OrderUserPage
				})
				this.OrderUserList = list.data
			}
		}
	}
</script>

<style scoped lang="less">
	/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
		background: #0052D9;
	}

	.checkBox {
		padding: 0 20px;
		font-size: 18px;
		display: flex;
		height: 80px;
		line-height: 80px;
		cursor: pointer;
		border-bottom: 1px solid #ECECEC;

		div {
			margin-right: 60px;
		}

		.checkActive {
			font-weight: bold;
			color: #0052D9;
			border-bottom: 3px solid #0052D9;
		}
	}

	.detail {
		padding: 10px;
		box-sizing: border-box;
		border: 1px solid #ECECEC;
		display: flex;
		width: 100%;
		align-items: center;
		margin-bottom: 22px;

		.detail-content {
			height: 100%;
			padding: 0px 10px 10px 0;
			flex: 1;
			overflow: hidden;

			.jieshao {
				margin-top: 10px;
				font-family: PingFang;
				font-weight: 400;
				color: #888888;
				line-height: 25px;
				height: 40px;
			}

			.company {
				margin-top: 5px;
				display: inline-block;
				padding: 0 10px;
				height: 29px;
				background: #E5EDFB;
				color: #0052D9;
				text-align: center;
				font-size: 14px;
				line-height: 29px;
			}

			.top {
				display: flex;
				justify-content: space-between;
				height: 40px;
				align-items: center;

				.username {
					font-size: 20px;
					font-weight: bold;
				}

				.letter {
					background: #FBF4E5;
					color: #D99D0E;
				}

				.guanzhu {
					background: #E5EDFB;
					color: #0052D9;
				}

				.fans {
					cursor: pointer;
					line-height: 38px;
					text-align: center;
					margin-left: 25px;
					width: 108px;
					height: 38px;
					border-radius: 2px;

					i {
						font-size: 18px;
						line-height: 20px;
					}
				}
			}
		}

		.detail-pic {
			width: 150px;
			flex-wrap: wrap;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;

			.image {
				width: 90px;
				height: 90px;
				overflow: hidden;
				border-radius: 50%;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.renzheng {
				margin-top: 10px;
				cursor: pointer;
				color: #222222;
				text-align: center;
				line-height: 33px;
				width: 83px;
				height: 33px;
				background: #EEEEEE;
			}
		}
	}

	.body-mid {
		padding: 30px 0;
		margin: 0 20px;
		width: 1120px;
		box-sizing: border-box;
		background: #fff;
	}
</style>